/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeAppEventListDto,
  ApiEnvelopeAppEventLocationsDto,
  ApiEnvelopeAppEventOverviewDto,
  ApiEnvelopeAppEventPerformanceDto,
  AppEventType,
  AppEventViewGetPerformanceDataAllTimeParams,
  AppEventViewGetPerformanceDataParams,
  AppEventViewGetWhereParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type appEventViewGetResponse200 = {
  data: ApiEnvelopeAppEventOverviewDto
  status: 200
}

export type appEventViewGetResponse401 = {
  data: ApiEnvelopeAppEventOverviewDto
  status: 401
}

export type appEventViewGetResponse403 = {
  data: ApiEnvelopeAppEventOverviewDto
  status: 403
}

export type appEventViewGetResponseSuccess = (appEventViewGetResponse200) & {
  headers: Headers;
};
export type appEventViewGetResponseError = (appEventViewGetResponse401 | appEventViewGetResponse403) & {
  headers: Headers;
};

export type appEventViewGetResponse = (appEventViewGetResponseSuccess | appEventViewGetResponseError)

export const getAppEventViewGetUrl = () => {




  return `/api/AppEventView`
}

export const useAppEventViewGetHook = (): ( options?: RequestInit) => Promise<appEventViewGetResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAppEventViewGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetInTimeRangeResponse200 = {
  data: ApiEnvelopeAppEventListDto
  status: 200
}

export type appEventViewGetInTimeRangeResponse401 = {
  data: ApiEnvelopeAppEventListDto
  status: 401
}

export type appEventViewGetInTimeRangeResponse403 = {
  data: ApiEnvelopeAppEventListDto
  status: 403
}

export type appEventViewGetInTimeRangeResponseSuccess = (appEventViewGetInTimeRangeResponse200) & {
  headers: Headers;
};
export type appEventViewGetInTimeRangeResponseError = (appEventViewGetInTimeRangeResponse401 | appEventViewGetInTimeRangeResponse403) & {
  headers: Headers;
};

export type appEventViewGetInTimeRangeResponse = (appEventViewGetInTimeRangeResponseSuccess | appEventViewGetInTimeRangeResponseError)

export const getAppEventViewGetInTimeRangeUrl = (from: string,
    to: string,) => {




  return `/api/AppEventView/${from}/${to}`
}

export const useAppEventViewGetInTimeRangeHook = (): (from: string,
    to: string, options?: RequestInit) => Promise<appEventViewGetInTimeRangeResponse> => {

      const customFetcher = useSfetchMutator();
      return (from: string,
    to: string, options?: RequestInit) => {

        return customFetcher(getAppEventViewGetInTimeRangeUrl(from,to),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetWhereResponse200 = {
  data: ApiEnvelopeAppEventListDto
  status: 200
}

export type appEventViewGetWhereResponse401 = {
  data: ApiEnvelopeAppEventListDto
  status: 401
}

export type appEventViewGetWhereResponse403 = {
  data: ApiEnvelopeAppEventListDto
  status: 403
}

export type appEventViewGetWhereResponseSuccess = (appEventViewGetWhereResponse200) & {
  headers: Headers;
};
export type appEventViewGetWhereResponseError = (appEventViewGetWhereResponse401 | appEventViewGetWhereResponse403) & {
  headers: Headers;
};

export type appEventViewGetWhereResponse = (appEventViewGetWhereResponseSuccess | appEventViewGetWhereResponseError)

export const getAppEventViewGetWhereUrl = (params?: AppEventViewGetWhereParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AppEventView/where?${stringifiedParams}` : `/api/AppEventView/where`
}

export const useAppEventViewGetWhereHook = (): (params?: AppEventViewGetWhereParams, options?: RequestInit) => Promise<appEventViewGetWhereResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: AppEventViewGetWhereParams, options?: RequestInit) => {

        return customFetcher(getAppEventViewGetWhereUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetByTypeResponse200 = {
  data: ApiEnvelopeAppEventListDto
  status: 200
}

export type appEventViewGetByTypeResponse401 = {
  data: ApiEnvelopeAppEventListDto
  status: 401
}

export type appEventViewGetByTypeResponse403 = {
  data: ApiEnvelopeAppEventListDto
  status: 403
}

export type appEventViewGetByTypeResponseSuccess = (appEventViewGetByTypeResponse200) & {
  headers: Headers;
};
export type appEventViewGetByTypeResponseError = (appEventViewGetByTypeResponse401 | appEventViewGetByTypeResponse403) & {
  headers: Headers;
};

export type appEventViewGetByTypeResponse = (appEventViewGetByTypeResponseSuccess | appEventViewGetByTypeResponseError)

export const getAppEventViewGetByTypeUrl = (type: AppEventType,) => {




  return `/api/AppEventView/type/${type}`
}

export const useAppEventViewGetByTypeHook = (): (type: AppEventType, options?: RequestInit) => Promise<appEventViewGetByTypeResponse> => {

      const customFetcher = useSfetchMutator();
      return (type: AppEventType, options?: RequestInit) => {

        return customFetcher(getAppEventViewGetByTypeUrl(type),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetPerformanceDataResponse200 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 200
}

export type appEventViewGetPerformanceDataResponse401 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 401
}

export type appEventViewGetPerformanceDataResponse403 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 403
}

export type appEventViewGetPerformanceDataResponseSuccess = (appEventViewGetPerformanceDataResponse200) & {
  headers: Headers;
};
export type appEventViewGetPerformanceDataResponseError = (appEventViewGetPerformanceDataResponse401 | appEventViewGetPerformanceDataResponse403) & {
  headers: Headers;
};

export type appEventViewGetPerformanceDataResponse = (appEventViewGetPerformanceDataResponseSuccess | appEventViewGetPerformanceDataResponseError)

export const getAppEventViewGetPerformanceDataUrl = (params?: AppEventViewGetPerformanceDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AppEventView/performance?${stringifiedParams}` : `/api/AppEventView/performance`
}

export const useAppEventViewGetPerformanceDataHook = (): (params?: AppEventViewGetPerformanceDataParams, options?: RequestInit) => Promise<appEventViewGetPerformanceDataResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: AppEventViewGetPerformanceDataParams, options?: RequestInit) => {

        return customFetcher(getAppEventViewGetPerformanceDataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetPerformanceDataAllTimeResponse200 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 200
}

export type appEventViewGetPerformanceDataAllTimeResponse401 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 401
}

export type appEventViewGetPerformanceDataAllTimeResponse403 = {
  data: ApiEnvelopeAppEventPerformanceDto
  status: 403
}

export type appEventViewGetPerformanceDataAllTimeResponseSuccess = (appEventViewGetPerformanceDataAllTimeResponse200) & {
  headers: Headers;
};
export type appEventViewGetPerformanceDataAllTimeResponseError = (appEventViewGetPerformanceDataAllTimeResponse401 | appEventViewGetPerformanceDataAllTimeResponse403) & {
  headers: Headers;
};

export type appEventViewGetPerformanceDataAllTimeResponse = (appEventViewGetPerformanceDataAllTimeResponseSuccess | appEventViewGetPerformanceDataAllTimeResponseError)

export const getAppEventViewGetPerformanceDataAllTimeUrl = (params?: AppEventViewGetPerformanceDataAllTimeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AppEventView/performancealltime?${stringifiedParams}` : `/api/AppEventView/performancealltime`
}

export const useAppEventViewGetPerformanceDataAllTimeHook = (): (params?: AppEventViewGetPerformanceDataAllTimeParams, options?: RequestInit) => Promise<appEventViewGetPerformanceDataAllTimeResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: AppEventViewGetPerformanceDataAllTimeParams, options?: RequestInit) => {

        return customFetcher(getAppEventViewGetPerformanceDataAllTimeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type appEventViewGetAllLoggedLocationsResponse200 = {
  data: ApiEnvelopeAppEventLocationsDto
  status: 200
}

export type appEventViewGetAllLoggedLocationsResponse401 = {
  data: ApiEnvelopeAppEventLocationsDto
  status: 401
}

export type appEventViewGetAllLoggedLocationsResponse403 = {
  data: ApiEnvelopeAppEventLocationsDto
  status: 403
}

export type appEventViewGetAllLoggedLocationsResponseSuccess = (appEventViewGetAllLoggedLocationsResponse200) & {
  headers: Headers;
};
export type appEventViewGetAllLoggedLocationsResponseError = (appEventViewGetAllLoggedLocationsResponse401 | appEventViewGetAllLoggedLocationsResponse403) & {
  headers: Headers;
};

export type appEventViewGetAllLoggedLocationsResponse = (appEventViewGetAllLoggedLocationsResponseSuccess | appEventViewGetAllLoggedLocationsResponseError)

export const getAppEventViewGetAllLoggedLocationsUrl = () => {




  return `/api/AppEventView/locations`
}

export const useAppEventViewGetAllLoggedLocationsHook = (): ( options?: RequestInit) => Promise<appEventViewGetAllLoggedLocationsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAppEventViewGetAllLoggedLocationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


